<p class="timestamp">{{ time() | date: 'HH:mm' }}</p>
